import React from "react";

const MemberShipPackageBooking = React.lazy(() => import("./index"));
const CreatePackageBooking = React.lazy(() =>
  import("../BookingFeatures/CreatePackageBooking")
);
const CreatePackageInvoiceBooking = React.lazy(() =>
  import("../BookingFeatures/CreatePackageInvoiceBooking")
);
const CreateInvoiceReceipt = React.lazy(() =>
  import("../BookingFeatures/CreateInvoiceReceipt")
);
const InvoiceTemplate = React.lazy(() =>
  import("../BookingFeatures/Template/InvoiceTemplate")
);
const InvoiceReceipt = React.lazy(() =>
  import("../BookingFeatures/Template/InvoiceReceipt")
);
const MembershipPackageBookingDetails = React.lazy(() =>
  import("./MembershipPackageBookingDetails")
);
const InvoiceReceiptDetail = React.lazy(() =>
  import("components/BookingFeatures/BookingDetails/InvoiceReceiptDetail")
);
const FreezingMembershipList = React.lazy(() =>
  import("./FreezingMembershipList")
);
const FreezingMembershipDetail = React.lazy(() =>
  import("./FreezingMembershipList/FreezingMembershipDetail")
);

export const MemberShipPackageBookingRoute = [
  {
    path: "/admin/memberShipPackageBookings",
    name: "MemberShipPackageBooking",
    element: <MemberShipPackageBooking />,
  },
  {
    path: "/admin/freezingMemberships",
    name: "FreezingMembershipList",
    element: <FreezingMembershipList />,
  },
  {
    path: "/admin/freezingMemberships/:id",
    name: "FreezingMembershipDetail",
    element: <FreezingMembershipDetail />,
  },
  {
    path: "/admin/memberShipPackageBookings/create",
    name: "CreatePackageBooking",
    element: <CreatePackageBooking />,
  },
  {
    path: "/admin/memberShipPackageBookings/create/:memberId",
    name: "CreatePackageBooking",
    element: <CreatePackageBooking />,
  },
  {
    path: "/admin/memberShipPackageBookings/createInvoice/:packageId",
    name: "CreatePackageInvoiceBooking",
    element: <CreatePackageInvoiceBooking />,
  },
  {
    path: "/admin/memberShipPackageBookings/createInvoiceReceipt/:packageId",
    name: "CreateInvoiceReceipt",
    element: <CreateInvoiceReceipt />,
  },
  {
    path: "/admin/memberShipPackageBookings/invoice/:invoiceId",
    name: "InvoiceReceipt",
    element: <InvoiceTemplate />,
  },
  {
    path: "/admin/memberShipPackageBookings/invoiceReceipt/:invoiceId",
    name: "InvoiceReceipt",
    element: <InvoiceReceipt />,
  },
  {
    path: "/admin/memberShipPackageBookings/:packageId",
    name: "PackageBookingDetail",
    element: <MembershipPackageBookingDetails />,
  },
  {
    path: "/admin/memberShipPackageBookings/:packageId/invoiceReceipt/:receiptId",
    name: "InvoiceReceiptDetail",
    element: <InvoiceReceiptDetail />,
  },
];
